<template>
  <CheckRbac :permissions="permissions">
    <template #default="{ granted }">
      <div
        :class="[{ readOnly: !granted && readOnly }]"
        :style="granted ? {} : { opacity }"
      >
        <slot :granted="granted" />
      </div>
    </template>
  </CheckRbac>
</template>

<script setup>
import CheckRbac from './CheckRbac.vue';

/**
 * Wraps slot content and visually disables it when the current user lacks
 * the required permissions. The slot is always rendered; when permissions
 * are not granted the wrapper gets reduced opacity and pointer/select events
 * are blocked. Exposes a `granted` slot prop so children can adapt further.
 */
defineOptions({ name: 'DisableRbac' });

defineProps({
  permissions: { type: Array, default: () => [], required: true },
  opacity: { type: Number, default: 0.5 },
  readOnly: { type: Boolean, default: true },
});
</script>

<style lang="less" scoped>
.readOnly {
  pointer-events: none;
  user-select: none;
}
</style>
